import { READ_SEARCH, RESET_SEARCH, SET_SEARCH_WORD } from "../actions";

const issues = (state = {}, action) => {
  switch (action.type) {
    case READ_SEARCH:
      return { ...state, ...action.response.success };
    case RESET_SEARCH:
      return {};
    case SET_SEARCH_WORD:
      return { ...state, word: action.word };
    default:
      return state;
  }
};

export default issues;
